import { COMMENT_FILE_TYPES, MAX_COMMENT_ATTACHMENTS, MAX_COMMENT_FILE_BYTES } from '@revival/contracts';

export type CommentFile = { clientId: string; file: File; capturedAt: string };
export const COMMENT_FILE_ACCEPT = Object.values(COMMENT_FILE_TYPES).concat('.jpeg').join(',');
export function addCommentFiles(current: CommentFile[], selected: File[]): CommentFile[] {
  if (current.length + selected.length > MAX_COMMENT_ATTACHMENTS) throw new Error('Attach up to six files per comment.');
  const additions = selected.map(file => {
    if (!file.size || file.size > MAX_COMMENT_FILE_BYTES) throw new Error(`${file.name}: choose a file up to 20 MB.`);
    const extension = '.' + (file.name.split('.').pop() ?? '').toLowerCase();
    const type = file.type && file.type !== 'application/octet-stream' ? file.type : Object.entries(COMMENT_FILE_TYPES).find(([, ext]) => ext === extension || extension === '.jpeg' && ext === '.jpg')?.[0];
    if (!type || !Object.hasOwn(COMMENT_FILE_TYPES, type)) throw new Error('Choose photos, PDF, Word (.docx), Excel (.xlsx) or text files.');
    return { clientId: crypto.randomUUID(), capturedAt: new Date().toISOString(), file: file.type === type ? file : new File([file], file.name, {type, lastModified:file.lastModified}) };
  });
  return [...current, ...additions];
}
